// import "./cart-test.min";
// import "./review-handler";
console.log("hello from since date reviews 3!!");
document.addEventListener("DOMContentLoaded", function() {
    $(window).resize();
    $983c62fab5e459da$var$applySinceDateReviews();
});
function $983c62fab5e459da$var$applySinceDateReviews() {
    let reviewDates = document.getElementsByClassName("reviewCreatedDate");
    const nowTime = new Date().getTime();
    const rtf = new Intl.RelativeTimeFormat("fr-FR");
    for(let i = 0; i < reviewDates.length; i++){
        const raw = reviewDates[i].textContent.trim();
        const [day, month, year, time] = raw.replace(" ", "/").split("/");
        const iso = `${year}-${month}-${day}T${time}`;
        let date = new Date(iso);
        const diff = date.getTime() - nowTime;
        let relativeDate = "";
        if (Math.abs(diff) < 60000) {
            const seconds = Math.floor(diff / 1000);
            relativeDate = rtf.format(seconds, "second");
        } else if (Math.abs(diff) < 3600000) {
            const minutes = Math.floor(diff / 60000);
            relativeDate = rtf.format(minutes, "minute");
        } else if (Math.abs(diff) < 86400000) {
            const hours = Math.floor(diff / 3600000);
            relativeDate = rtf.format(hours, "hour");
        } else if (Math.abs(diff) < 604800000) {
            const days = Math.floor(diff / 86400000);
            relativeDate = rtf.format(days, "day");
        } else if (Math.abs(diff) < 2592000000) {
            const weeks = Math.floor(diff / 604800000);
            relativeDate = rtf.format(weeks, "week");
        } else if (Math.abs(diff) < 31536000000) {
            const months = Math.floor(diff / 2592000000);
            relativeDate = rtf.format(months, "month");
        } else {
            const years = Math.floor(diff / 31536000000);
            relativeDate = rtf.format(years, "year");
        }
        reviewDates[i].textContent = relativeDate;
    }
}


// alert-system.js - Premium Custom Design (Framework Independent)
// Improved: Spinner for all alerts, single event listener, cleaner code
let $c3b85bb004b7ebec$var$alertListenerAdded = false;
const $c3b85bb004b7ebec$export$516836c6a9dfc573 = ()=>{
    const el = document.getElementById("notificationAlert");
    if (el) {
        el.style.opacity = "0";
        setTimeout(()=>{
            if (el.parentElement) el.parentElement.removeChild(el);
        }, 300);
    }
    // Also remove any stacked alerts
    const stackedAlerts = document.querySelectorAll(".custom-alert-stack");
    stackedAlerts.forEach((alert)=>{
        if (alert.parentElement) alert.parentElement.removeChild(alert);
    });
};
const $c3b85bb004b7ebec$export$de026b00723010c1 = (style, title, message)=>{
    $c3b85bb004b7ebec$export$516836c6a9dfc573();
    let msg;
    let code;
    const spinner = `<div class="alert-spinner"></div>`;
    let deleteBtn = "";
    if (style === "danger") {
        msg = message.message || message;
        code = message.statusCode;
    } else msg = message;
    // Only primary (loading) alerts have no close button
    if (style !== "primary") deleteBtn = `<button class="alert-close-btn" aria-label="Fermer">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"/>
      </svg>
    </button>`;
    // Color mapping
    const colorMap = {
        danger: {
            primary: "#dc2626",
            light: "#fee2e2",
            dark: "#b91c1c"
        },
        success: {
            primary: "#059669",
            light: "#d1fae5",
            dark: "#047857"
        },
        warning: {
            primary: "#d97706",
            light: "#fef3c7",
            dark: "#b45309"
        },
        info: {
            primary: "#2563eb",
            light: "#dbeafe",
            dark: "#1d4ed8"
        },
        primary: {
            primary: "#7c3aed",
            light: "#ede9fe",
            dark: "#6d28d9"
        }
    };
    const colors = colorMap[style] || colorMap.info;
    const markupAlert = `
    <div id="notificationAlert" class="custom-alert custom-alert-${style}" 
         style="--alert-color: ${colors.primary}; 
                --alert-light: ${colors.light}; 
                --alert-dark: ${colors.dark};">
      <div class="alert-content">
        <div class="alert-header">
          <div class="alert-header-left">
          <div class="alert-title">${title}</div>
            ${spinner}
          </div>
          ${deleteBtn}
        </div>
        <div class="alert-body">
          <strong>${msg}</strong>
        </div>
      </div>
    </div>
  `;
    // Inject styles if not already present
    if (!document.querySelector("#alert-styles")) {
        const styleElement = document.createElement("style");
        styleElement.id = "alert-styles";
        styleElement.textContent = $c3b85bb004b7ebec$var$getAlertStyles();
        document.head.appendChild(styleElement);
    }
    // Add global click listener once
    if (!$c3b85bb004b7ebec$var$alertListenerAdded) {
        document.addEventListener("click", (event)=>{
            const closeBtn = event.target.closest(".alert-close-btn");
            if (closeBtn) {
                const alert = closeBtn.closest(".custom-alert, .custom-alert-stack");
                if (alert) {
                    alert.style.opacity = "0";
                    setTimeout(()=>{
                        if (alert.parentElement) alert.parentElement.removeChild(alert);
                    }, 300);
                }
            }
        });
        $c3b85bb004b7ebec$var$alertListenerAdded = true;
    }
    document.body.insertAdjacentHTML("afterbegin", markupAlert);
    // Animate in
    setTimeout(()=>{
        const alert = document.getElementById("notificationAlert");
        if (alert) alert.classList.add("alert-show");
    }, 10);
    // Auto hide after 9 seconds (except for primary/loading)
    if (style !== "primary") setTimeout(()=>{
        $c3b85bb004b7ebec$export$516836c6a9dfc573();
    }, 3000);
    // Special handling for code 417
    if (code === 417) {
        const signButton = document.getElementById("sign");
        if (signButton) signButton.click();
    }
    // Clear on page navigation
    window.addEventListener("pageshow", $c3b85bb004b7ebec$export$516836c6a9dfc573);
};
// Helper function for all CSS styles
function $c3b85bb004b7ebec$var$getAlertStyles() {
    return `
    /* Custom Alert System - Framework Independent */
    .custom-alert {
      position: fixed;
      top: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(-20px);
      min-width: 300px;
      max-width: 500px;
      width: 90%;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .custom-alert.alert-show {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
    }
    
    .alert-content {
      background: white;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.1),
        0 8px 16px rgba(0, 0, 0, 0.08),
        0 0 0 1px rgba(0, 0, 0, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
      border-left: 4px solid var(--alert-color);
      position: relative;
      overflow: hidden;
    }
    
    .alert-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
    }
    
    .alert-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    
    .alert-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      line-height: 1.4;
    }
    
    .alert-close-btn {
      background: rgba(0, 0, 0, 0.05);
      border: none;
      width: 32px;
      height: 32px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #6b7280;
      transition: all 0.2s ease;
      flex-shrink: 0;
      padding: 0;
    }
    
    .alert-close-btn:hover {
      background: rgba(0, 0, 0, 0.1);
      color: #374151;
      transform: scale(1.05);
    }
    
    .alert-close-btn:active {
      transform: scale(0.95);
    }
    
    .alert-close-btn svg {
      width: 14px;
      height: 14px;
    }
    
    .alert-body {
      color: #4b5563;
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 8px;
    }
    
    .alert-body strong {
      font-weight: 500;
      color: #374151;
    }
    
    /* Spinner for all alerts */
    .alert-spinner {
      width: 20px;
      height: 20px;
      border: 3px solid var(--alert-light);
      border-top-color: var(--alert-color);
      border-radius: 50%;
      animation: alertSpinner 1s linear infinite;
      flex-shrink: 0;
    }
    
    /* Alert type specific adjustments */
    .custom-alert-danger .alert-content {
      border-left-color: #dc2626;
    }
    
    .custom-alert-success .alert-content {
      border-left-color: #059669;
    }
    
    .custom-alert-warning .alert-content {
      border-left-color: #d97706;
    }
    
    .custom-alert-info .alert-content {
      border-left-color: #2563eb;
    }
    
    .custom-alert-primary .alert-content {
      border-left-color: #7c3aed;
    }
    
    /* Animation keyframes */
    @keyframes alertSpinner {
      to {
        transform: rotate(360deg);
      }
    }
    
    /* Stack for multiple alerts */
    .custom-alert-stack {
      position: fixed;
      top: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9998;
      width: 300px;
      pointer-events: none;
      transition: all 0.3s ease;
    }
    
    .custom-alert-stack .alert-content {
      pointer-events: auto;
      margin-bottom: 12px;
      transform: scale(0.95);
      opacity: 0.9;
    }
    
    /* Responsive */
    @media (max-width: 640px) {
      .custom-alert {
        width: 95%;
        min-width: unset;
        top: 16px;
      }
      
      .alert-content {
        padding: 16px;
      }
      
      .alert-title {
        font-size: 15px;
      }
      
      .alert-body {
        font-size: 13px;
      }
    }
    
    /* Dark mode support */
    @media (prefers-color-scheme: dark) {
      .alert-content {
        background: #1f2937;
        box-shadow: 
          0 20px 40px rgba(0, 0, 0, 0.3),
          0 8px 16px rgba(0, 0, 0, 0.25),
          0 0 0 1px rgba(255, 255, 255, 0.05);
      }
      
      .alert-title {
        color: #f9fafb;
      }
      
      .alert-body {
        color: #d1d5db;
      }
      
      .alert-body strong {
        color: #e5e7eb;
      }
      
      .alert-close-btn {
        background: rgba(255, 255, 255, 0.1);
        color: #9ca3af;
      }
      
      .alert-close-btn:hover {
        background: rgba(255, 255, 255, 0.15);
        color: #d1d5db;
      }
    }
    
    /* Print styles */
    @media print {
      .custom-alert {
        display: none !important;
      }
    }
  `;
}
const $c3b85bb004b7ebec$export$acb3aa652eb61a96 = (style, title, message, position = 1)=>{
    const stackId = `alert-stack-${Date.now()}`;
    let msg;
    if (style === "danger") msg = message.message || message;
    else msg = message;
    const colors = {
        danger: "#dc2626",
        success: "#059669",
        warning: "#d97706",
        info: "#2563eb",
        primary: "#7c3aed"
    };
    const markup = `
    <div id="${stackId}" class="custom-alert-stack" style="top: ${24 + position * 80}px;">
      <div class="alert-content" style="border-left-color: ${colors[style] || colors.info};">
        <div class="alert-header">
          <div class="alert-header-left">
            <div class="alert-spinner"></div>
            <div class="alert-title">${title}</div>
          </div>
          <button class="alert-close-btn" aria-label="Fermer">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"/>
            </svg>
          </button>
        </div>
        <div class="alert-body">
          <strong>${msg}</strong>
        </div>
      </div>
    </div>
  `;
    // Inject styles if needed
    if (!document.querySelector("#alert-styles")) {
        const styleElement = document.createElement("style");
        styleElement.id = "alert-styles";
        styleElement.textContent = $c3b85bb004b7ebec$var$getAlertStyles();
        document.head.appendChild(styleElement);
    }
    document.body.insertAdjacentHTML("afterbegin", markup);
    // Animate in
    setTimeout(()=>{
        const alert = document.getElementById(stackId);
        if (alert) {
            alert.style.opacity = "1";
            alert.style.transform = "translateX(-50%) translateY(0)";
        }
    }, 10);
    // Auto dismiss
    setTimeout(()=>{
        const alert = document.getElementById(stackId);
        if (alert) {
            alert.style.opacity = "0";
            setTimeout(()=>{
                if (alert.parentElement) alert.parentElement.removeChild(alert);
            }, 300);
        }
    }, 9000);
};
const $c3b85bb004b7ebec$export$f6cef6fcf9ca4e17 = (style, message, duration = 3000)=>{
    const toastId = `toast-${Date.now()}`;
    const colors = {
        danger: "#dc2626",
        success: "#059669",
        warning: "#d97706",
        info: "#2563eb",
        primary: "#7c3aed"
    };
    const markup = `
    <div id="${toastId}" class="custom-toast" 
         style="--toast-color: ${colors[style] || colors.info};">
      <div class="toast-content">
        <div class="toast-message">${message}</div>
      </div>
    </div>
  `;
    // Add toast styles if not present
    if (!document.querySelector("#toast-styles")) {
        const styleElement = document.createElement("style");
        styleElement.id = "toast-styles";
        styleElement.textContent = `
      .custom-toast {
        position: fixed;
        bottom: 24px;
        right: 24px;
        min-width: 200px;
        max-width: 350px;
        background: white;
        border-radius: 12px;
        padding: 14px 18px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        border-left: 3px solid var(--toast-color);
        z-index: 9997;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .custom-toast.toast-show {
        opacity: 1;
        transform: translateY(0);
      }
      
      .toast-message {
        color: #374151;
        font-size: 14px;
        line-height: 1.4;
      }
      
      @media (prefers-color-scheme: dark) {
        .custom-toast {
          background: #1f2937;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        }
        
        .toast-message {
          color: #f3f4f6;
        }
      }
      
      @media (max-width: 640px) {
        .custom-toast {
          left: 16px;
          right: 16px;
          bottom: 16px;
          max-width: none;
        }
      }
    `;
        document.head.appendChild(styleElement);
    }
    document.body.insertAdjacentHTML("beforeend", markup);
    // Animate in
    setTimeout(()=>{
        const toast = document.getElementById(toastId);
        if (toast) toast.classList.add("toast-show");
    }, 10);
    // Auto dismiss
    setTimeout(()=>{
        const toast = document.getElementById(toastId);
        if (toast) {
            toast.classList.remove("toast-show");
            setTimeout(()=>{
                if (toast.parentElement) toast.parentElement.removeChild(toast);
            }, 300);
        }
    }, duration);
};
// Global functions for backward compatibility
window.hideAlert = $c3b85bb004b7ebec$export$516836c6a9dfc573;
window.showAlert = $c3b85bb004b7ebec$export$de026b00723010c1;
window.showToast = $c3b85bb004b7ebec$export$f6cef6fcf9ca4e17;
window.showStackedAlert = $c3b85bb004b7ebec$export$acb3aa652eb61a96;
// Auto-initialize on load
document.addEventListener("DOMContentLoaded", ()=>{
    // If there are any existing alerts from server-side, style them
    const existingAlerts = document.querySelectorAll(".message");
    existingAlerts.forEach((alert)=>{
    // Optional: convert existing Bulma alerts to custom ones
    });
});


console.log("hello from manageProducts.js");
const $cc55cd2f53598418$var$deleteProduct = async (currentStoreId, productId, productName)=>{
    try {
        await axios.delete(`/api/v1/stores/${currentStoreId}/products/${productId}`);
        alert(`${productName} supprim\xe9 avec succ\xe8s!, cliquez sur "OK" pour recharger !`);
        location.reload();
    } catch (err) {
        console.log(">>>>>> Erreur Suppression  : ", err.response.data);
        alert(err.response.data.message);
    }
};
const $cc55cd2f53598418$var$addProduct = async (currentStoreId, data)=>{
    try {
        const res = await axios.post(`/api/v1/stores/${currentStoreId}/products`, data);
        if (res.data.status === "success") {
            (0, $c3b85bb004b7ebec$export$de026b00723010c1)("success", "Success", "Produit ajout\xe9 avec succ\xe8s !");
            setTimeout(()=>{
                location.assign("/addproduct");
            }, 1000);
        }
    } catch (err) {
        console.log(err);
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", err.response.data);
    }
};
const $cc55cd2f53598418$var$updateProduct = async (currentStoreId, productId, data)=>{
    // console.log(
    //   "Updating product with data (raw entries):",
    //   Array.from(data.entries())
    // );
    // return;
    try {
        const res = await axios.patch(`/api/v1/stores/${currentStoreId}/products/${productId}`, data);
        if (res.data.status === "success") {
            (0, $c3b85bb004b7ebec$export$de026b00723010c1)("success", "Success", "Produit mis \xe0 jour avec succ\xe8s !");
            setTimeout(()=>{
                location.reload();
            }, 2000);
        }
    } catch (err) {
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", err.response.data);
    }
};
const $cc55cd2f53598418$var$activationHandler = async (currentStoreId, productId, value)=>{
    try {
        const res = await axios.patch(`/api/v1/stores/${currentStoreId}/products/${productId}`, {
            active: value
        });
        if (res.data.status === "success") location.reload();
    } catch (err) {
        console.log(">>>>>> error activation : ", err.response.data.message);
        alert(err.response.data.message);
    }
};
const $cc55cd2f53598418$var$generateBoostOrder = async function(type, user, store, product, pricingId) {
    try {
        const res = await axios.post(`/api/v1/orders`, {
            type: type,
            user: user,
            store: store,
            product: product,
            pricingId: pricingId
        });
        if (res.data.status === "success") {
            (0, $c3b85bb004b7ebec$export$de026b00723010c1)("success", "Success !", "Votre commande a \xe9t\xe9 plac\xe9e avec succ\xe8s, veuillez contacter le service client pour confirmation !");
            location.reload();
        }
    } catch (err) {
        console.log(">>>>>> erreur de Suppression : ", err.response.data.message);
        alert(err.response.data.message);
    }
};
const $cc55cd2f53598418$var$addProductForm = document.getElementById("add-product-form");
const $cc55cd2f53598418$var$updateProductBtn = $(".update-product-btn");
const $cc55cd2f53598418$var$modalProductId = $("#modal-product-id");
const $cc55cd2f53598418$var$dBtn = $(".delete-product-btn");
const $cc55cd2f53598418$var$storeActivateProductBtn = $(".store-activate-product-btn");
const $cc55cd2f53598418$var$storeBlockProductBtn = $(".store-inactive-product-btn");
const $cc55cd2f53598418$var$boostProductBtn = $(".boost-product-btn");
if ($cc55cd2f53598418$var$storeActivateProductBtn) $cc55cd2f53598418$var$storeActivateProductBtn.on("click", function() {
    const conf = confirm("\xcates-vous s\xfbr de vouloir inactiver le produit? ");
    const productId = $(this).data("id");
    const currentStoreId = $(this).data("store");
    if (conf) $cc55cd2f53598418$var$activationHandler(currentStoreId, productId, 0);
});
if ($cc55cd2f53598418$var$storeBlockProductBtn) $cc55cd2f53598418$var$storeBlockProductBtn.on("click", function() {
    const conf = confirm("\xcates-vous s\xfbr que vous souhaitez activer ce produit ? ");
    const currentStoreId = $(this).data("store");
    const productId = $(this).data("id");
    if (conf) $cc55cd2f53598418$var$activationHandler(currentStoreId, productId, 1);
});
if ($cc55cd2f53598418$var$addProductForm) $cc55cd2f53598418$var$addProductForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Ajout de produit, veuillez patienter ...");
    // Get form values
    const name = document.getElementById("productname").value;
    const smallDescription = document.getElementById("smallDescription").value;
    const price = document.getElementById("price").value;
    const devise = document.getElementById("devise").value;
    const stock = document.getElementById("stock").value;
    const category = document.getElementById("productCategory").value;
    const city = document.getElementById("productCity").value;
    const municipality = document.getElementById("productMunicipality").value;
    const tags = Array.from(document.querySelectorAll(".input.product-tags"), (e)=>e.value);
    const brand = document.getElementById("brand").value;
    const manufacturer = document.getElementById("manufacturer").value;
    const description = document.getElementById("productDescription").value;
    const currentStoreId = document.getElementById("storeId").value;
    // Get thumbnail (required)
    const thumbnail = document.getElementById("file-upload-productThumbnail").files[0];
    // Get additional images (optional, multiple)
    const additionalImages = document.getElementById("file-upload-productImages").files;
    // Validate required fields
    if (!name) {
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Erreur !", "Le nom du produit est requis");
        return;
    }
    if (!price) {
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Erreur !", "Le prix du produit est requis");
        return;
    }
    if (!thumbnail) {
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Erreur !", "L'image principale (thumbnail) est requise");
        return;
    }
    const data = new FormData();
    // Append basic product data
    data.append("name", name);
    data.append("smallDescription", smallDescription);
    data.append("price", price);
    data.append("devise", devise);
    data.append("stock", stock);
    data.append("category", category);
    data.append("city", city);
    data.append("municipality", municipality);
    // Append tags (keep your existing logic)
    if (tags[0]) data.append("tags", tags[0]);
    else data.append("tags", "Kinshasa");
    if (tags[1]) data.append("tags", tags[1]);
    else data.append("tags", "Qualit\xe9");
    if (tags[2]) data.append("tags", tags[2]);
    else data.append("tags", "Super");
    if (tags[3]) data.append("tags", tags[3]);
    else data.append("tags", "Original");
    data.append("brand", brand);
    data.append("manufacturer", manufacturer);
    data.append("description", description);
    // Append thumbnail (required)
    data.append("thumbnail", thumbnail);
    // Append additional images (optional - 0 to unlimited)
    if (additionalImages && additionalImages.length > 0) // Append all selected images with field name "images"
    for(let i = 0; i < additionalImages.length; i++)data.append("images", additionalImages[i]);
    // Note: If no additional images are selected, we don't append anything
    // The backend will handle this and use default image
    // Log for debugging
    console.log("Submitting product with:");
    console.log("- Name:", name);
    console.log("- Price:", price);
    console.log("- Thumbnail file:", thumbnail ? thumbnail.name : "none");
    console.log("- Additional images:", additionalImages ? additionalImages.length : 0);
    // Call your existing addProduct function
    $cc55cd2f53598418$var$addProduct(currentStoreId, data);
});
if ($cc55cd2f53598418$var$updateProductBtn) $cc55cd2f53598418$var$updateProductBtn.on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    const productId = $(this).data("id");
    const currentStoreId = $(this).data("store");
    const name = $(this).data("name");
    const smallDescription = $(this).data("smalldescription");
    const price = $(this).data("price");
    const devise = $(this).data("devise");
    const stock = $(this).data("stock");
    const category = $(this).data("category");
    const city = $(this).data("city");
    const municipality = $(this).data("municipality");
    const tags = $(this).data("tags");
    const brand = $(this).data("brand");
    const manufacturer = $(this).data("manufacturer");
    const description = $(this).data("description");
    const thumbnail = $(this).data("thumbnail");
    // Get images array - parse if it's a JSON string
    let images = $(this).data("images");
    if (typeof images === "string") try {
        images = JSON.parse(images);
    } catch (error) {
        console.error("Error parsing images data:", error);
        images = [];
    }
    // Ensure images is an array
    if (!Array.isArray(images)) images = [];
    // Populate form fields
    $("#update-product-modal #title").text(`Modifier Produit : ${name}`);
    $("#update-product-modal #name").val(name);
    $("#update-product-modal #smallDescription").val(smallDescription);
    $("#update-product-modal #price").val(price);
    $("#update-product-modal #devise #dev-option1").val(devise).text(devise);
    $("#update-product-modal #stock").val(stock);
    $("#update-product-modal #category #cat-option1").text(category);
    $("#update-product-modal #city #city-option1").text(city);
    $("#update-product-modal #municipality #mun-option1").text(municipality);
    $("#update-product-modal .tag1").val(tags.split(",")[0] || "");
    $("#update-product-modal .tag2").val(tags.split(",")[1] || "");
    $("#update-product-modal .tag3").val(tags.split(",")[2] || "");
    $("#update-product-modal .tag4").val(tags.split(",")[3] || "");
    $("#update-product-modal #manufacturer").val(manufacturer);
    $("#update-product-modal #brand").val(brand);
    $("#update-product-modal #description").val(description);
    $("#update-product-modal #thumbnail").attr("src", `/assets/img/${thumbnail}`);
    // Initialize the image preview with existing images
    $cc55cd2f53598418$var$initializeUpdateProductImages(images);
    // Store product ID for later use
    $("#update-product-modal").data("productId", productId);
    $("#update-product-modal").data("storeId", currentStoreId);
    // Set up the update button click handler
    $("#modal-update-product-btn").off("click").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        // alert("Clicked !");
        $cc55cd2f53598418$var$updateProductHandler(productId, currentStoreId);
    });
});
// Global array for update modal images
let $cc55cd2f53598418$var$updateProductImages = [];
// Function to initialize existing images in update modal
function $cc55cd2f53598418$var$initializeUpdateProductImages(imagesArray) {
    $cc55cd2f53598418$var$updateProductImages = []; // Reset the array
    const previewContainer = document.getElementById("product-images-preview-update");
    previewContainer.innerHTML = "";
    // Reset the file input
    const fileInput = document.getElementById("file-upload-productImages-update");
    if (fileInput) fileInput.value = "";
    // Add each existing image to the preview
    if (imagesArray && imagesArray.length > 0) imagesArray.forEach((imageFilename, index)=>{
        if (imageFilename && imageFilename.trim() !== "") $cc55cd2f53598418$var$addExistingImageToPreview(imageFilename, index + 1);
    });
    $cc55cd2f53598418$var$updateUpdateProductImageCount();
}
// Function to add an existing image to the preview
function $cc55cd2f53598418$var$addExistingImageToPreview(imageFilename, position) {
    const previewContainer = document.getElementById("product-images-preview-update");
    // Create a unique ID for this image
    const fileId = `existing-${Date.now()}-${Math.random()}`;
    // Store in our global array
    $cc55cd2f53598418$var$updateProductImages.push({
        id: fileId,
        filename: imageFilename,
        isExisting: true,
        position: position
    });
    // Create preview element
    const previewDiv = document.createElement("div");
    previewDiv.className = "preview-item";
    previewDiv.dataset.fileId = fileId;
    previewDiv.style.position = "relative";
    previewDiv.style.width = "200px";
    previewDiv.style.margin = "10px";
    previewDiv.style.order = position;
    // Create image
    const img = document.createElement("img");
    img.id = `preview-update-img-${fileId}`;
    img.className = "file-name";
    img.style.width = "100%";
    img.style.height = "150px";
    img.style.objectFit = "cover";
    img.style.borderRadius = "8px";
    img.style.border = "2px solid #4CAF50";
    img.alt = `Image ${position}`;
    img.src = `/assets/img/${imageFilename}`;
    // Create remove button
    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "delete is-small";
    removeBtn.style.position = "absolute";
    removeBtn.style.top = "5px";
    removeBtn.style.right = "5px";
    removeBtn.style.backgroundColor = "red";
    removeBtn.style.borderRadius = "50%";
    removeBtn.innerHTML = "&times;";
    removeBtn.onclick = function() {
        $cc55cd2f53598418$var$removeUpdateProductImage(fileId);
    };
    // Create info div
    const info = document.createElement("div");
    info.className = "is-size-7 mt-2 has-text-centered";
    info.innerHTML = `
    <span class="tag is-success is-light is-small">Existante</span><br>
    ${imageFilename.length > 20 ? imageFilename.substring(0, 20) + "..." : imageFilename}
  `;
    // Create position badge
    const positionBadge = document.createElement("span");
    positionBadge.className = "tag is-dark is-small";
    positionBadge.style.position = "absolute";
    positionBadge.style.top = "5px";
    positionBadge.style.left = "5px";
    positionBadge.textContent = position;
    positionBadge.style.fontSize = "0.7rem";
    previewDiv.appendChild(img);
    previewDiv.appendChild(positionBadge);
    previewDiv.appendChild(removeBtn);
    previewDiv.appendChild(info);
    previewContainer.appendChild(previewDiv);
}
// Function to remove an image from update preview
function $cc55cd2f53598418$var$removeUpdateProductImage(fileId) {
    // Remove from our array
    const index = $cc55cd2f53598418$var$updateProductImages.findIndex((img)=>img.id === fileId);
    if (index !== -1) $cc55cd2f53598418$var$updateProductImages.splice(index, 1);
    // Remove from DOM
    const previewDiv = document.querySelector(`[data-file-id="${fileId}"]`);
    if (previewDiv) previewDiv.remove();
    // Update positions and count
    $cc55cd2f53598418$var$updateUpdateProductPositions();
    $cc55cd2f53598418$var$updateUpdateProductImageCount();
}
// Function to update positions of all images
function $cc55cd2f53598418$var$updateUpdateProductPositions() {
    const previewItems = document.querySelectorAll("#product-images-preview-update .preview-item");
    previewItems.forEach((item, index)=>{
        const positionBadge = item.querySelector(".tag.is-dark");
        if (positionBadge) positionBadge.textContent = index + 1;
        // Update order for CSS
        item.style.order = index + 1;
        // Update position in our array
        const fileId = item.dataset.fileId;
        const imgIndex = $cc55cd2f53598418$var$updateProductImages.findIndex((img)=>img.id === fileId);
        if (imgIndex !== -1) $cc55cd2f53598418$var$updateProductImages[imgIndex].position = index + 1;
    });
}
// Function to update image count display
function $cc55cd2f53598418$var$updateUpdateProductImageCount() {
    let countDisplay = document.getElementById("update-image-count-display");
    if (!countDisplay) {
        const fileCta = document.querySelector("#update-product-modal .file-cta");
        if (fileCta) {
            countDisplay = document.createElement("span");
            countDisplay.id = "update-image-count-display";
            countDisplay.className = "ml-2 tag is-info is-light";
            fileCta.appendChild(countDisplay);
        }
    }
    if (countDisplay) countDisplay.textContent = `${$cc55cd2f53598418$var$updateProductImages.length}/20 images`;
}
// Function to handle new image uploads in update modal
function $cc55cd2f53598418$var$handleUpdateProductImageUpload(e) {
    const fileInput = e.target;
    const newFiles = fileInput.files;
    const previewContainer = document.getElementById("product-images-preview-update");
    // Check if we have space for more images
    const maxImages = 20;
    const availableSlots = maxImages - $cc55cd2f53598418$var$updateProductImages.length;
    if (availableSlots <= 0) {
        // Show warning
        const warning = document.createElement("div");
        warning.className = "notification is-warning is-light mt-2";
        warning.style.width = "100%";
        warning.innerHTML = `<p>Limite de 20 images atteinte. Vous ne pouvez pas ajouter plus d'images.</p>`;
        // Remove any existing warning
        const existingWarning = previewContainer.querySelector(".notification.is-warning");
        if (existingWarning) existingWarning.remove();
        previewContainer.appendChild(warning);
        return;
    }
    // Process new files
    const filesToProcess = Array.from(newFiles).slice(0, availableSlots);
    filesToProcess.forEach((file, index)=>{
        // Check if it's an image
        if (!file.type.match(/image.*/)) {
            console.warn(`File ${file.name} is not an image`);
            return;
        }
        // Add to our array
        const fileId = `new-${Date.now()}-${Math.random()}`;
        $cc55cd2f53598418$var$updateProductImages.push({
            id: fileId,
            file: file,
            isExisting: false,
            isNew: true,
            position: $cc55cd2f53598418$var$updateProductImages.length + 1
        });
        // Create preview
        const reader = new FileReader();
        reader.onload = function(e) {
            $cc55cd2f53598418$var$addNewImageToPreview(fileId, file.name, e.target.result, $cc55cd2f53598418$var$updateProductImages.length);
        };
        reader.readAsDataURL(file);
    });
    // Show warning if some files were ignored
    if (newFiles.length > availableSlots) {
        const warning = document.createElement("div");
        warning.className = "notification is-warning is-light mt-2";
        warning.style.width = "100%";
        warning.innerHTML = `<p>Maximum ${maxImages} images autoris\xe9es. ${newFiles.length - availableSlots} image(s) ignor\xe9e(s).</p>`;
        const existingWarning = previewContainer.querySelector(".notification.is-warning");
        if (existingWarning) existingWarning.remove();
        previewContainer.appendChild(warning);
    }
    $cc55cd2f53598418$var$updateUpdateProductImageCount();
}
// Function to add a new image to preview
function $cc55cd2f53598418$var$addNewImageToPreview(fileId, fileName, dataUrl, position) {
    const previewContainer = document.getElementById("product-images-preview-update");
    const previewDiv = document.createElement("div");
    previewDiv.className = "preview-item";
    previewDiv.dataset.fileId = fileId;
    previewDiv.style.position = "relative";
    previewDiv.style.width = "200px";
    previewDiv.style.margin = "10px";
    previewDiv.style.order = position;
    previewDiv.style.animation = "fadeIn 0.3s ease";
    // Create image
    const img = document.createElement("img");
    img.id = `preview-update-img-${fileId}`;
    img.className = "file-name";
    img.style.width = "100%";
    img.style.height = "150px";
    img.style.objectFit = "cover";
    img.style.borderRadius = "8px";
    img.style.border = "2px solid #2196F3";
    img.alt = fileName;
    img.src = dataUrl;
    // Create remove button
    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "delete is-small";
    removeBtn.style.position = "absolute";
    removeBtn.style.top = "5px";
    removeBtn.style.right = "5px";
    removeBtn.style.backgroundColor = "red";
    removeBtn.style.borderRadius = "50%";
    removeBtn.innerHTML = "&times;";
    removeBtn.onclick = function() {
        $cc55cd2f53598418$var$removeUpdateProductImage(fileId);
    };
    // Create info div
    const info = document.createElement("div");
    info.className = "is-size-7 mt-2 has-text-centered";
    info.innerHTML = `
    <span class="tag is-info is-light is-small">Nouvelle</span><br>
    ${fileName.length > 20 ? fileName.substring(0, 20) + "..." : fileName}
  `;
    // Create position badge
    const positionBadge = document.createElement("span");
    positionBadge.className = "tag is-dark is-small";
    positionBadge.style.position = "absolute";
    positionBadge.style.top = "5px";
    positionBadge.style.left = "5px";
    positionBadge.textContent = position;
    positionBadge.style.fontSize = "0.7rem";
    previewDiv.appendChild(img);
    previewDiv.appendChild(positionBadge);
    previewDiv.appendChild(removeBtn);
    previewDiv.appendChild(info);
    previewContainer.appendChild(previewDiv);
}
// Function to handle the update product form submission
function $cc55cd2f53598418$var$updateProductHandler(productId, storeId) {
    (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Updating product ...");
    const data = new FormData();
    // Get form values
    data.append("name", $("#update-product-modal #name").val());
    data.append("smallDescription", $("#update-product-modal #smallDescription").val());
    data.append("price", $("#update-product-modal #price").val());
    data.append("devise", $("#update-product-modal #devise").val());
    data.append("stock", $("#update-product-modal #stock").val());
    data.append("category", $("#update-product-modal #category").val());
    data.append("city", $("#update-product-modal #city").val());
    data.append("municipality", $("#update-product-modal #municipality").val());
    data.append("tags", $("#update-product-modal .tag1").val());
    data.append("tags", $("#update-product-modal .tag2").val());
    data.append("tags", $("#update-product-modal .tag3").val());
    data.append("tags", $("#update-product-modal .tag4").val());
    data.append("brand", $("#update-product-modal #brand").val());
    data.append("manufacturer", $("#update-product-modal #manufacturer").val());
    data.append("description", $("#update-product-modal #description").val());
    // Get thumbnail
    const thumbnailFile = document.querySelector("#update-product-modal #file-upload").files[0];
    if (thumbnailFile) data.append("thumbnail", thumbnailFile);
    // Add new images
    const newImages = $cc55cd2f53598418$var$updateProductImages.filter((img)=>!img.isExisting && img.file).map((img)=>img.file);
    newImages.forEach((file)=>{
        data.append("images", file);
    });
    // Add existing images that should be kept
    const existingImages = $cc55cd2f53598418$var$updateProductImages.filter((img)=>img.isExisting).map((img)=>img.filename);
    existingImages.forEach((filename)=>{
        data.append("images", filename);
    });
    // // Build a readable preview of the FormData (includes file names for File objects)
    // const formDataPreview = {};
    // for (const [key, value] of data.entries()) {
    //   if (value instanceof File) {
    //     // accumulate multiple files under same key as array of names
    //     if (formDataPreview[key]) {
    //       if (Array.isArray(formDataPreview[key])) {
    //         formDataPreview[key].push(value.name);
    //       } else {
    //         formDataPreview[key] = [formDataPreview[key], value.name];
    //       }
    //     } else {
    //       formDataPreview[key] = value.name;
    //     }
    //   } else {
    //     if (formDataPreview[key]) {
    //       if (Array.isArray(formDataPreview[key])) {
    //         formDataPreview[key].push(value);
    //       } else {
    //         formDataPreview[key] = [formDataPreview[key], value];
    //       }
    //     } else {
    //       formDataPreview[key] = value;
    //     }
    //   }
    // }
    // console.log("Updating product with data (preview):", formDataPreview);
    // // Also log raw entries for full inspection
    // console.log("Updating product raw entries:", Array.from(data.entries()));
    // return;
    // Call the update function
    $cc55cd2f53598418$var$updateProduct(storeId, productId, data);
}
// Set up event listener for the update modal image input
document.addEventListener("DOMContentLoaded", function() {
    const updateImageInput = document.getElementById("file-upload-productImages-update");
    if (updateImageInput) {
        // Remove any existing event listeners
        const newInput = updateImageInput.cloneNode(true);
        updateImageInput.parentNode.replaceChild(newInput, updateImageInput);
        // Add new event listener
        newInput.addEventListener("change", $cc55cd2f53598418$var$handleUpdateProductImageUpload);
    }
});
if ($cc55cd2f53598418$var$dBtn) $cc55cd2f53598418$var$dBtn.on("click", function(e) {
    e.stopPropagation();
    const productId = $(this).data("id");
    const productName = $(this).data("name");
    const currentStoreId = $(this).data("store");
    $cc55cd2f53598418$var$modalProductId.text(productName);
    $("#modalDelBtn").one("click", function(e) {
        e.stopPropagation();
        $cc55cd2f53598418$var$deleteProduct(currentStoreId, productId, productName);
    });
});
if ($cc55cd2f53598418$var$boostProductBtn) $cc55cd2f53598418$var$boostProductBtn.on("click", function(e) {
    e.stopPropagation();
    const productId = $(this).data("id");
    const productName = $(this).data("name");
    const pricingId = $(this).data("boostid");
    const boostName = $(this).data("bname");
    const boostStamp = $(this).data("stamp");
    const boostPrice = $(this).data("price");
    const type = "boost";
    const store = $(this).data("store");
    const user = $(this).data("user");
    const boostLimit = $(this).data("limit");
    const boostDescription = $(this).data("description");
    const boostDuration = $(this).data("duration");
    $("#modal-boost-product-name").text(productName);
    $("#modal-boost-stamp").attr("src", "/assets/img/" + boostStamp);
    $("#modal-boost-description").text(boostDescription);
    $("#modalBoostBtn").one("click", function(e) {
        e.stopPropagation();
        $cc55cd2f53598418$var$generateBoostOrder(type, user, store, productId, pricingId);
    });
});
// ------------------------------------------------------------
// Helpers
// ------------------------------------------------------------
const $cc55cd2f53598418$var$getVal = (id)=>{
    var _document$getElementB;
    return (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
};
const $cc55cd2f53598418$var$alertSuccessReload = (msg)=>{
    (0, $c3b85bb004b7ebec$export$de026b00723010c1)("success", "Success", msg);
    setTimeout(()=>location.reload(), 1200);
};
// ------------------------------------------------------------
// API CALLS
// ------------------------------------------------------------
async function $cc55cd2f53598418$var$addProductReview(productId, productStore, review, rating) {
    try {
        const res = await axios.post(`/api/v1/products/${productId}/reviews`, {
            review: review,
            rating: rating,
            productStore: productStore
        });
        if (res.data.status === "success") $cc55cd2f53598418$var$alertSuccessReload("Avis ajout\xe9 avec succ\xe8s !");
    } catch (err) {
        var _err$response;
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || "Erreur serveur");
    }
}
async function $cc55cd2f53598418$var$updateProductReview(productId, reviewId, review, rating) {
    try {
        const res = await axios.patch(`/api/v1/products/${productId}/reviews/${reviewId}`, {
            review: review,
            rating: rating
        });
        if (res.data.status === "success") $cc55cd2f53598418$var$alertSuccessReload("Avis mis \xe0 jour avec succ\xe8s !");
    } catch (err) {
        var _err$response2;
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", ((_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) || "Erreur serveur");
    }
}
async function $cc55cd2f53598418$var$deleteProductReview(productId, reviewId) {
    try {
        await axios.delete(`/api/v1/products/${productId}/reviews/${reviewId}`);
        $cc55cd2f53598418$var$alertSuccessReload("Avis supprim\xe9 avec succ\xe8s !");
    } catch (err) {
        var _err$response3;
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", ((_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.data) || "Erreur serveur");
    }
}
async function $cc55cd2f53598418$var$adminDeleteProductReview(reviewId) {
    try {
        await axios.delete(`/api/v1/reviews/${reviewId}`);
        $cc55cd2f53598418$var$alertSuccessReload("Avis supprim\xe9 avec succ\xe8s !");
    } catch (err) {
        var _err$response4;
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("danger", "Alert", ((_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.data) || "Erreur serveur");
    }
}
// ------------------------------------------------------------
// EVENT HANDLERS - Individual event listeners
// ------------------------------------------------------------
// Initialize all event listeners
function $cc55cd2f53598418$var$initEventListeners() {
    // ADD review button
    const addBtn = document.getElementById("add-product-review-btn");
    if (addBtn) addBtn.addEventListener("click", function(e) {
        e.preventDefault();
        if (!$cc55cd2f53598418$var$getVal("productReview") || $cc55cd2f53598418$var$getVal("productReview").trim() === "") {
            console.log("getVal review:", $cc55cd2f53598418$var$getVal("productReview"));
            (0, $c3b85bb004b7ebec$export$de026b00723010c1)("warnig", "Alert", "Le commentaire ne peut pas \xeatre vide. Veuillez r\xe9essayer.");
            return;
        }
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Ajout de votre avis...");
        $cc55cd2f53598418$var$addProductReview($cc55cd2f53598418$var$getVal("productId"), $cc55cd2f53598418$var$getVal("productStore"), $cc55cd2f53598418$var$getVal("productReview"), $cc55cd2f53598418$var$getVal("product-rating"));
    });
    // UPDATE review button
    const updateBtn = document.getElementById("update-product-review-btn");
    if (updateBtn) updateBtn.addEventListener("click", function(e) {
        e.preventDefault();
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Modification de votre avis ...");
        $cc55cd2f53598418$var$updateProductReview($cc55cd2f53598418$var$getVal("productId"), $cc55cd2f53598418$var$getVal("currentUserProductReviewId"), $cc55cd2f53598418$var$getVal("productReview"), $cc55cd2f53598418$var$getVal("product-rating"));
    });
    // DELETE review (user) button
    const deleteBtn = document.getElementById("delete-product-review-btn");
    if (deleteBtn) deleteBtn.addEventListener("click", function(e) {
        e.preventDefault();
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Suppression de votre avis...");
        $cc55cd2f53598418$var$deleteProductReview($cc55cd2f53598418$var$getVal("productId"), $cc55cd2f53598418$var$getVal("currentUserProductReviewId"));
    });
}
// Event delegation for dynamically added admin delete buttons
// We attach a single listener to a parent container that exists on page load
const $cc55cd2f53598418$var$reviewsContainer = document.getElementById("reviews-container") || document.querySelector(".reviews-table") || document.body;
$cc55cd2f53598418$var$reviewsContainer.addEventListener("click", function(e) {
    // Check if the clicked element has the admin delete class
    if (e.target.classList.contains("admin-delete-product-review-btn")) {
        e.preventDefault();
        const reviewId = e.target.dataset.reviewId;
        // console.log("Admin delete review ID:", reviewId);
        // return;
        (0, $c3b85bb004b7ebec$export$de026b00723010c1)("primary", "Yay !", "Suppression de l'avis ...");
        $cc55cd2f53598418$var$adminDeleteProductReview(reviewId);
    }
});
// Initialize event listeners when DOM is loaded
document.addEventListener("DOMContentLoaded", $cc55cd2f53598418$var$initEventListeners);
// Re-initialize event listeners after AJAX content is loaded (if applicable)
if (typeof reinitializeComponents === "function") {
    // If you have a function that reloads content via AJAX, call initEventListeners there
    const originalReinitialize = reinitializeComponents;
    reinitializeComponents = function() {
        originalReinitialize();
        $cc55cd2f53598418$var$initEventListeners();
    };
} // ============================================================




//# sourceMappingURL=product.js.map
